import { SrBuilding, SrDevice, SrEvacuationSummary, SrMarshalPhone, SrMembership, SrStaff } from '@cloudsign/shared';
import { z } from 'zod';

export {
  SrBuilding,
  SrBuildingCreate,
  SrBuildingUpdate,
  SrDevice,
  SrEvacuationSummary,
  SrInvite,
  SrMarshalPhone,
  SrMembership,
  SrOrder,
  SrPairingCode,
  SrPairingCodeCreate,
  SrStaff,
  SrStaffAdd,
} from '@cloudsign/shared';

/** Platform routes of the module (contract s5 short forms read as /shared-reception/platform/buildings). */
export const BASE = '/shared-reception/platform/buildings';

export const BuildingArray = z.array(SrBuilding);
export const MembershipArray = z.array(SrMembership);
export const StaffArray = z.array(SrStaff);
export const DeviceArray = z.array(SrDevice);
export const PhoneArray = z.array(SrMarshalPhone);
export const EvacuationArray = z.array(SrEvacuationSummary);

export const keys = {
  buildings: ['shared-reception', 'platform', 'buildings'] as const,
  building: (id: string) => ['shared-reception', 'platform', 'building', id] as const,
  memberships: (id: string) => ['shared-reception', 'platform', 'memberships', id] as const,
  staff: (id: string) => ['shared-reception', 'platform', 'staff', id] as const,
  devices: (id: string) => ['shared-reception', 'platform', 'devices', id] as const,
  phones: (id: string) => ['shared-reception', 'platform', 'phones', id] as const,
  evacuations: (id: string) => ['shared-reception', 'platform', 'evacuations', id] as const,
  tenants: (search: string) => ['shared-reception', 'platform', 'tenants', search] as const,
};

/** Memberships that sit on the kiosk (and so in the order list). */
export const LINKED: readonly string[] = ['active', 'paused', 'leaving'];

export const statusTone = (s: string): 'neutral' | 'good' | 'warn' | 'bad' =>
  s === 'active' ? 'good' : s === 'paused' || s === 'leaving' || s === 'invited' ? 'warn' : 'neutral';
